import React, { useCallback, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { useSelector, useDispatch } from 'react-redux';
import {
  createLoyalty,
  displayTransferBalanceModal,
} from '../../Loyalty/loyaltyActions';
import styled from 'styled-components';
import appConfig from '../../../../app-config';
import { PrimaryButton } from '../../../components/Buttons';
import FlatButton from '../../../components/Buttons/FlatButton';
import { LoyaltyTransferBalanceForm } from './LoyaltyTransferBalanceForm';
import { set } from 'lodash';
import { LoyaltyTransferBalanceSubmit } from './LoyaltyTransferBalanceSubmit';
import { requestDigitalCard } from '../../PaymentMethods/paymentMethodsActions';
const Wrapper = styled.div`
  width: 100%;
  padding: 20px 20px 40px 20px;
`;
const Remove = styled.span`
  margin-right: 12px;
  cursor: pointer;
  font-size: 20px;
`;

const PageTitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  margin: 10px 15px;
  font-size: 16px;
  font-weight: 500;
`;

const MessageWrapper = styled.div`
  padding: 0 15px;
  font-size: 16px;
  margin-top: 10px;
  a {
    color: #0d66e4 !important;
    text-decoration: none;
  }
`;

export const LoyaltyTransferBalanceContainer = () => {
  const dispatch = useDispatch();
  const [loyaltyValues, setLoyaltyValues] = useState();
  const [transferStep, setTransferStep] = useState('form');
  const { isTransferBalanceModalVisible } = useSelector(
    (state) => state.loyaltyReducer
  );
  const handleCloseModal = () => {
    dispatch(displayTransferBalanceModal(false));
  };
  const handleNavigateToSubmit = useCallback(
    (values) => {
      setLoyaltyValues(values);
      setTransferStep('submit');
    },
    [dispatch, setTransferStep]
  );
  const handleTransferBalance = useCallback(() => {
    const { loyalty_number, pin } = loyaltyValues;
    const newLoyaltyNumber = loyalty_number.replaceAll(' ', '');
    dispatch(requestDigitalCard(newLoyaltyNumber, pin));
  }, [dispatch, setTransferStep, loyaltyValues]);
  return (
    <Dialog
      id='Auth-AuthContainer-Dialog'
      aria-labelledby='payment-methods'
      aria-describedby='payment-methods'
      open={isTransferBalanceModalVisible}
      onBackdropClick={handleCloseModal}
      fullWidth={window.innerWidth < 786}
      fullScreen={typeof window !== 'undefined' && window.innerWidth < 786}
      PaperProps={{ style: { zIndex: 1000, borderRadius: 20 } }}
      scroll='body'
    >
      <Wrapper>
        <PageTitleWrapper>
          <div style={{ textAlign: 'center' }}>Balance Transfer</div>
          <Remove onClick={handleCloseModal}>
            <i className='fal fa-times' />
          </Remove>
        </PageTitleWrapper>
        <MessageWrapper>
          Looking to merge cards with the one in your wallet? Please contact{' '}
          <a href='mailto:feedback@burritoboyz.ca'>feedback@burritoboyz.ca</a>
           for assistance.
        </MessageWrapper>

        {/* {transferStep === 'form' && (
          <FormWrapper>
            <LoyaltyTransferBalanceForm
              handleNavigateToSubmit={handleNavigateToSubmit}
              // handleTransferBalance={handleTransferBalance}
            />
          </FormWrapper>
        )}
        {transferStep === 'submit' && (
          <LoyaltyTransferBalanceSubmit
            handleCloseModal={handleCloseModal}
            handleTransferBalance={handleTransferBalance}
            loyaltyPayload={loyaltyValues}
          />
        )} */}
      </Wrapper>
    </Dialog>
  );
};
